import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { posts } from "../data/posts";

import post1 from "../assets/post1.png";
// thêm ảnh nếu có nhiều

const imageMap = {
  post1: post1,
};

function PostDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const foundPost = posts.find((p) => p.slug === slug);

    if (foundPost) {
      setPost(foundPost);
    } else {
      setError("Không tìm thấy bài viết.");
    }
  }, [slug]);

  if (error) {
    return <div className="text-red-500 text-center mt-10">{error}</div>;
  }

  if (!post) {
    return <div className="text-center mt-10">Đang tải bài viết...</div>;
  }

  const imageSrc = imageMap[post.image];

  return (
    <div className="max-w-3xl mx-auto p-4 bg-white rounded shadow mt-6">
      <h1 className="text-2xl text-center font-bold mb-4">{post.title}</h1>

      {imageSrc && (
        <img
          src={imageSrc}
          alt={post.title}
          className="w-full h-64 object-cover rounded mb-4"
        />
      )}

      <p className="text-gray-600 mb-4">{post.excerpt}</p>

      <div className="prose prose-sm sm:prose lg:prose-lg xl:prose-xl max-w-none [&_a]:underline [&_a]:text-blue-600">
        <ReactMarkdown>{post.content_md}</ReactMarkdown>
      </div>
    </div>
  );
}

export default PostDetail;